export function sendFilterEvent(label, value) {
    if (label === 'other' || label === 'characteristics') {
        label += '-' + value;
    }
    try {
        analytics.submitEventAction(awp, analyticsObjects.actions.gotoAction, analyticsObjects.labelElements.filter + '-' + label);
    } catch (e) {

    }
}

